export default __webpack_public_path__ + "static/01-02-prepare-bring-favourites-18fa64772b9ffed718c3ae5862652fb6.mp4";